import { StyledFormListWrapper } from 'components/atoms/FormListWrapper/styles';
import React from 'react';
import FormErrorLabel from 'components/atoms/FormErrorLabel';
import { Box } from '@mui/material';

type Props = {
  children: React.ReactNode;
  isError: boolean;
  errorMessage?: string;
};

export const FormListWrapper = ({ children, isError, errorMessage }: Props) => (
  <>
    <StyledFormListWrapper isError={isError}>{children}</StyledFormListWrapper>
    <Box sx={{ width: "100%" }}>
      {errorMessage && isError && <FormErrorLabel label={errorMessage} />}
    </Box>
  </>
);
